import React, { useEffect } from "react";
import HeroSectionWithProduct from "../components/HeroSectionWithProduct";
import TimingGateFeature from "../components/TimingGateFeature";
import WhyChooseTimingGate from "../components/WhyChooseTimingGate";
import KeyFeatureProduct from "../components/KeyFeatureProduct";
import HowItWorks from "../components/HowItWorks";
import { Helmet } from "react-helmet-async";

const Timinggates = () => {
  // Scroll to top when the page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
     <>
      <Helmet>
        <title>
          Aikyam Timing Gate | Wireless Sprint Timing & Jump Assessment System
        </title>

        <meta
          name="description"
          content="Discover the Aikyam Timing Gate, India's advanced wireless timing system for sprint timing, agility testing, jump assessment, reaction time analysis, and athlete performance tracking."
        />

        <meta
          name="keywords"
          content="Timing Gate, Wireless Timing Gate, Sprint Timing System, Speed Testing, Jump Assessment, Agility Testing, Sports Technology, Athlete Performance, Sports Science India, Aikyam Sports"
        />

        <link
          rel="canonical"
          href="https://aikyamsports.com/timing-gates"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Aikyam Timing Gate | Wireless Performance Measurement System"
        />
        <meta
          property="og:description"
          content="Improve speed, agility, reaction time and jump performance with the Aikyam Timing Gate."
        />
        <meta
          property="og:image"
          content="https://aikyamsports.com/logo11.png"
        />
        <meta
          property="og:url"
          content="https://aikyamsports.com/timing-gates"
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          name="twitter:title"
          content="Aikyam Timing Gate"
        />
        <meta
          name="twitter:description"
          content="Wireless timing gate system for athlete performance measurement."
        />
        <meta
          name="twitter:image"
          content="https://aikyamsports.com/logo11.png"
        />
      </Helmet>
    <div>
      <HeroSectionWithProduct />
      {/* <p className="text-lg text-gray-600 text-center py-8 px-4">
        Discover the Aikyam Timing Gates – your ultimate tool for precision performance tracking, delivering real-time data to unlock your athletic potential.
      </p> */}
      <TimingGateFeature />
      <WhyChooseTimingGate />
      <KeyFeatureProduct />
      <HowItWorks />
    </div>
    </>
  );
};

export default Timinggates;
